import Login from "../Pages/Login/Login";
import Notifications from "./Components/Notifications/Notifications";
import Layout from "../views/Layout/Layout";
import Settings from "../Pages/Settings/Settings";
import Dashboard from "../Pages/Dashboard/Dashboard";
import Forms from "./Components/Forms/Forms";
import Clipboard from "./Components/Clipboard/Clipboard";
import Box from "./Components/Box/Box";
import PasswordRecovery from "../Pages/PasswordRecovery/PasswordRecovery";
import Users from "../Pages/Users/Users";
import DetailBox from "./Components/DetailBox/DetailBox";
import Search from "./Components/Search/Search";
import Dialogs from "./Components/Dialogs2/Dialogs";

const App = {
    debug: false,
    page: "",

    ajaxUrl: {
        switch: (location.protocol ? location.protocol : 'http') + "//" + window.location.hostname + "/" + "ajax.php"
    },
    ajaxSendProtection: 0,

    currentDate: new Date(),

    project: null,
    isAdmin: false,

    init: function () {

        this.page = $("body").attr('page');
        this.isAdmin = $('[component="Layout"]').hasClass('admin');

        $(document).ready(function ($) {
            $('body').addClass('ready');

            App.isLandscape = window.innerWidth > window.innerHeight;
            App.isPortrait = !App.isLandscape;
            App.start();
        });

        this.loading = $('[element="loading"]');
        this.contentHeader = $('[component="ContentHeader"]');
        this.contentHeaderHeight = Number(this.contentHeader.outerHeight());
        this.pageContent = $('[element="content"]');
        this.pageProperties = $('main[page]');

        this.bind();
    },

    start() {
        this.setProject();

        if (this.deviceIsIphone()) {
            $('body').attr('device', 'iphone');
            App.isIphone = true;
            $('[aos]').each((i, el) => {
                $(el).attr('data-aos', $(el).attr('aos'));
                $(el).removeAttr('aos');
            })
        }

        this.setInteractionObserver();

        this.loadComponents();
        this.loadPlugins();
        this.loadPages();

        setTimeout(function () {
            App.hideLoading();
        }, 500);
    },

    bind() {
        $("input, textarea").on("focus", (element) => {
            let content = this.pageContent;
            let setPos = Number(content.scrollTop()) - App.contentHeaderHeight;

            if (!App.isElementInViewport(element.target)) {
                $(content).animate({
                    //scrollTop: setPos - 100
                }, 250);
            }
        });

        $("a").on("click", (element) => {
            if ($(element.currentTarget).attr("href") === '#' && !$(element.currentTarget).data()) {
                element.preventDefault();
            }
        });

        $(document).on("click", ".ajaxAsync", function (element) {
            clearTimeout(App.ajaxSendProtection);

            App.ajaxSendProtection = setTimeout(() => {
                setTimeout(() => {
                    let button = $(element.currentTarget).data();

                    let data = {
                        data: button.data
                    };

                    if (button.post) {
                        data.parameters = button.post;
                    }

                    App.showLoading();
                    App.ajax(
                        button.library,
                        button.event,
                        data,
                        (response) => {
                            Clipboard.create();
                        }
                    )

                    Layout.hideModal(this.dialog);

                }, 0);

            }, 0);
        });

        $(document).on("click", ".async", function (element) {
            clearTimeout(App.ajaxSendProtection);

            const buttonEl = $(element.currentTarget);

            if (buttonEl.is(".confirm")) {
                Dialogs.init();
                Dialogs.setHeader(buttonEl.html());
                Dialogs.setButton(buttonEl);
                Dialogs.show();

                return;
            }

            App.ajaxSendProtection = setTimeout(() => {
                setTimeout(() => {
                    const button = buttonEl.data();

                    let data = {
                        data: button.data
                    };

                    if (button.post) {
                        data.parameters = button.post;
                    }

                    App.showLoading();
                    App.ajax2(
                        button.job,
                        data,
                        (response) => {
                            Clipboard.create();
                            App.setInteractionObserver();
                        }
                    )

                    Layout.hideModal(this.dialog);

                }, 0);

            }, 800);
        });
    },

    loadComponents() {
        Notifications.init();
        Layout.init();
        Clipboard.init();
        Box.init();
        DetailBox.init();
        Search.init();
    },

    loadPages() {
        Login.init();
        Settings.init();
        Dashboard.init();
        PasswordRecovery.init();
        Users.init();
    },

    loadPlugins() {
        require('./plugins/plugin_timestamp.js');
    },

    // setProperties() {
    //     App.isLandscape = window.innerWidth > window.innerHeight;
    //     App.isPortrait = !App.isLandscape;
    //     App.isDesktop = window.innerWidth > 1000;
    //     App.isTablet = window.innerWidth < 1000 && window.innerWidth > 740;
    //     App.isMobile = window.innerWidth < 740;
    // },
    //
    // resize: function () {
    //
    // },

    deviceIsIphone() {
        if (/iP(hone|od|ad)/.test(navigator.platform)) {
            // supports iOS 2.0 and later: <http://bit.ly/TJjs1V>
            const v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
            return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
        } else {
            return null;
        }
    },

    setProject() {
        this.project = $("body").attr("project");
    },

    showLoading() {
        this.loading.fadeIn(250);
    },

    hideLoading() {
        this.loading.fadeOut(800);
    },

    redirect(data) {

        if (data.delay) {
            setTimeout(function () {

                if (data.target == '_blank')
                    window.open(data.url, '_blank');
                else
                    window.location = data.url;
            }, data.delay);
        } else {
            window.location = data.url;
        }
    },

    setInteractionObserver() {

        const elements = document.querySelectorAll('.io');

        const options = {
            root: null, // Nastavit na null, pokud chceme sledovat viditelnost v celém viewportu
            rootMargin: '0px', // Okraje kolem cílového prvku, na kterých závisí aktivace pozorování
            threshold: 0.5 // Hodnota od 0.0 do 1.0, která určuje, kolik procent prvek musí být viditelný, aby došlo k aktivaci
        };

        const callback = (entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // Prvek vstoupil do viewportu nebo na něj překrývá
                    // Zde můžete provést akce, které mají být provedeny, když je prvek viditelný
                    //console.log('Prvek je viditelný');
                    entry.target.classList.add('visible');
                } else {
                    // Prvek opustil viewport
                    // Zde můžete provést akce, které mají být provedeny, když prvek není viditelný
                    //console.log('Prvek není viditelný');
                    entry.target.classList.remove('visible');
                }
            });
        };

        const observer = new IntersectionObserver(callback, options);

        elements.forEach((element) => {
            observer.observe(element);
        });
    },

    isElementInViewport(el) {

        if (typeof jQuery === "function" && el instanceof jQuery) {
            el = el[0];
        }

        let rect = el.getBoundingClientRect();

        return (
            (rect.top - App.contentHeaderHeight) >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
            rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
        );
    },

    getCronJobLink(cron, test = true) {

        if (typeof CRON_ADRESS_SECURED === 'undefined') {
            console.error("Missing variable CRON_ADRESS_SECURED");
            return;
        }

        if (typeof CRON_REQUEST === 'undefined') {
            console.error("Missing variable CRON_REQUEST");
            return;
        }

        let address = CRON_REQUEST + "&job=" + cron + (window.location.search).replace("?", "&");

        if (test) {
            address += "&test=true";
        }

        if (!address.includes("year")) {
            address += "&year=" + CRON_YEAR;
        }

        if (!address.includes("month")) {
            address += "&month=" + CRON_MONTH;
        }

        return address;
    },

    ajax(library, event, data = [], callback = null) {

        $.ajax({
            url: App.ajaxUrl.switch,
            type: 'post',
            data: {
                library: library,
                event: event,
                data: data
            },
            success: function (response) {

                if (!response) {
                    return;
                }

                let jsonResponse = JSON.parse(response);

                Forms.success(null, jsonResponse);

                if (typeof callback === 'function') {
                    callback(jsonResponse);
                }
            },
        });
    },

    ajax2(job, data = [], callback = null) {

        $.ajax({
            url: App.ajaxUrl.switch,
            type: 'post',
            data: {
                job: job,
                ...data,
                ...this.global
            },
            success: function (response) {

                if (!response) {
                    return;
                }

                let jsonResponse = JSON.parse(response);

                Forms.success(null, jsonResponse);

                if (typeof callback === 'function') {
                    callback(jsonResponse);
                }
            },
        });
    },

    isJson(jsonString) {
        let isValidJSON = true;

        try {
            JSON.parse(jsonString)
        } catch {
            isValidJSON = false
        }

        return isValidJSON;
    },

    removeTagsFromString(string) {
        return string.replace(/(<([^>]+)>)/gi, "");
    },
}

export default App;